<template>
  <div>
    <nav-breadcrumb :menu="[{label: '放款对账'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import PayPledgeFinancingComponent from '../../components/PayFinancingComponent'
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'FinancingCashJournalPayList',
    data() {
      return {
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '放款时间',
            field: 'pay__payDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            name: '放款金额(元)',
            field: 'pay__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '收款账户',
            field: 'cj__inboundAccountDesc',
          },
          {
            name: '放款账户',
            field: 'cj__outboundAccountDesc',
          },
          {
            name: '流水号',
            field: 'pay__reference'
          },
          {
            name: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            name: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            name: '客户手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '贷款用途',
            field: 'fi__intendedUse'
          },
        ],
        payTransactionId: '',
        dialogVisible: false,
        payAccountList: [],
        loanAccountList: [],
        filters: {
          form: {
            fi__transactionNo: '',
            u__customerName: '',
            ct__debtorName: '',
            fi__transactionDate: [],
            ct__productName: ''
          },
          columns: [
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'i__contactPerson'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            {
              label: '贷款用途',
              field: 'fi__intendedUse',
              component: 'el-select',
              options: []
            },
            {
              label: '放款日期',
              component: 'date-range-picker',
              field: 'pay__payDate'
            },
            {
              label: '放款账户',
              component: 'el-select',
              field: 'cj__outboundAccountDesc',
              options:[]
            },
            {
              label: '贷款编号',
              component: 'el-input',
              field: 'fi__transactionNo'
            },
            {
              label: '流水号',
              component: 'el-input',
              field: 'pay__reference'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerCashJournalPayList()
          }
        },
        actions: [
          {
            label: '导出',
            class: 'el-icon-download el-button--primary',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/financing/Payment.List?format=xlsx',
                query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            // 'xlist.search.cj.referenceType': 'PAY',
            // 'xlist.search.cj.referenceType.op': 'eq',
            'xlist.sort.dataField': 'pay.payDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerCashJournalPayList()
      }
    },
    mounted() {
      this.getCustomerCashJournalPayList()
    },
    components: {
      DataTable,
      PayPledgeFinancingComponent
    },
    methods: {
      getCustomerCashJournalPayList: function () {
        xhr.getCustomerPaymentList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinancingCashJournalPayList.vue